import { getProviderSettings, GetProviderSettingsResponse } from '@uplift/api';
import { useQuery } from '@tanstack/react-query';
import omit from 'lodash/omit';
import { ContactName } from '@uplift/types';

export type SettingsData = {
  contacts: {
    mobile?: string;
    work?: string;
    home?: string;
    mobileVerified?: boolean;
    mobileContactId?: string;
  };
} & Omit<GetProviderSettingsResponse, 'contacts'>;

export const useSettingsData = (userId: string): { isLoading: boolean; data: SettingsData } => {
  const { data, isInitialLoading: isLoading } = useQuery({
    queryKey: [ 'user', userId, 'settings' ],
    queryFn: () => getProviderSettings(null)
  });

  const initialContacts: SettingsData['contacts'] = {
    mobile: undefined,
    work: undefined,
    home: undefined,
  };

  const contacts = (data?.contacts ?? []).reduce((acc, cur): SettingsData['contacts'] => {
    switch (cur.name) {
      case ContactName.mobile:
        acc[cur.name] = cur.value;
        acc.mobileVerified = cur.verified;
        acc.mobileContactId = cur.id;
        break;
      case ContactName.home:
      case ContactName.work:
        acc[cur.name] = cur.value;
        break;
    }

    return acc;
  }, initialContacts);

  return {
    isLoading,
    data: {
      ...omit(data, 'contacts'),
      contacts
    }
  };
};
